import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "subwrap"
};
const _hoisted_3 = {
  class: "subitemcon"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "hastitle"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", {
  class: "notitle"
}, [/*#__PURE__*/_createElementVNode("span")], -1);
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 0,
  class: "subitemimglist"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 1,
  class: "subitemimg"
};
const _hoisted_13 = ["src"];
export default {
  __name: 'hcs',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      alias: 'hcs',
      isLoad: false,
      listInfo: []
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'gen_info',
        'exts': 'alias=' + FFdata.alias,
        msg: ''
      }, res => {
        FFdata.listInfo = res.infodata;
        FFdata.isLoad = true;
      });
      proxy.$store.SET_NAVALIAS(FFdata.alias);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _unref(FFdata).isLoad ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listInfo, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "subitem3",
          key: item.id
        }, [_createElementVNode("div", _hoisted_3, [item.title ? (_openBlock(), _createElementBlock("dl", _hoisted_4, [_createElementVNode("dt", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("dd", {
          class: "editor2",
          innerHTML: item.content
        }, null, 8, _hoisted_6)])) : (_openBlock(), _createElementBlock("dl", _hoisted_7, [_hoisted_8, _createElementVNode("dd", {
          class: "editor2",
          innerHTML: item.content
        }, null, 8, _hoisted_9)]))]), item.imgs ? (_openBlock(), _createElementBlock("dl", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgs.split(','), (item, index) => {
          return _openBlock(), _createElementBlock("dd", {
            key: index
          }, [_createElementVNode("img", {
            src: item
          }, null, 8, _hoisted_11)]);
        }), 128))])) : _createCommentVNode("", true), item.cover ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_13)])) : _createCommentVNode("", true)]);
      }), 128))])])) : _createCommentVNode("", true);
    };
  }
};